import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReviewEntryDetailTitleRow = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: ${Spacing.S8};
  justify-content: space-between;
`

export const ReviewEntryDetailTitleText = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`

export const ReviewEntryDetailStatusTag = styled.div`
  flex-shrink: 0;
`
